import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/azp/agent/_work/5/s/frontend/layouts/default.vue").then(m => m.default || m)),
  "external-forms": defineAsyncComponent(() => import("/azp/agent/_work/5/s/frontend/layouts/external-forms.vue").then(m => m.default || m)),
  "maintenance-layout": defineAsyncComponent(() => import("/azp/agent/_work/5/s/frontend/layouts/maintenance-layout.vue").then(m => m.default || m))
}